import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MxFormControlMessagesComponent } from './mx.form-control-messages.component';

export const COMPONENTS: any[] = [
  MxFormControlMessagesComponent,
];

@NgModule({
  imports: [CommonModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class MxFormControlMessagesModule {}
